import { ref } from 'vue';
import { offersApi } from '../services/offers.api';
import { useApiConfig } from '../../../composables/useApi';
import type { OfferDto, OfferFormData, OfferImage } from '../types/offer.types';

export function useOffers(opts: { archived?: boolean } = {}) {
  const offers = ref<OfferDto[]>([]);
  const loading = ref(false);
  const api = useApiConfig();

  const fetchOffers = async () => {
    loading.value = true;
    try {
      const res = opts.archived
        ? await offersApi.listArchivedWithConfig(api, {})
        : await offersApi.listWithConfig(api, {});
      offers.value = res?.data ?? [];
    } finally {
      loading.value = false;
    }
  };

  const saveOffer = async (data: OfferFormData & { images?: OfferImage[] }) => {
    if (data.id) {
      return offersApi.updateWithConfig(api, data.id, data);
    }
    return offersApi.createWithConfig(api, data);
  };

  const deleteOffer = async (id: number) => {
    return offersApi.deleteWithConfig(api, id);
  };

  return { offers, loading, fetchOffers, saveOffer, deleteOffer };
}
